"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagCA = function FlagCA(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "92.81",
    y: "1",
    width: "225.98",
    height: "268.36",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94-122a7.06,7.06,0,0,0-7.06,7.06V139.3a7.07,7.07,0,0,0,7.06,7.06h84.75V-122Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54-122H124.79V146.36h84.75a7.07,7.07,0,0,0,7.06-7.06V-114.94a7.06,7.06,0,0,0-7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M54.66,43.19l41.9-23.95L87,14.43a7,7,0,0,1-3.84-7.25l3.12-23.45L68.49-11.11a7.06,7.06,0,0,1-8.87-5.26L57.93-24,41.27-4.55a3.5,3.5,0,0,1-6.11-2.87l7.11-41.37-10.89,3a7,7,0,0,1-8.09-3.48L11.82-70.79v0h0v0L.33-49.29a7,7,0,0,1-8.09,3.48l-10.9-3,7.12,41.37a3.5,3.5,0,0,1-6.11,2.87L-34.31-24-36-16.37a7.07,7.07,0,0,1-8.87,5.26l-17.74-5.16,3.13,23.45a7.07,7.07,0,0,1-3.85,7.25l-9.61,4.81,41.9,24a10.2,10.2,0,0,1,4.5,12.42l-3.59,9.59L5.78,62.13A3.33,3.33,0,0,1,9.4,65.55L8.27,104h7.06L14.2,65.55a3.33,3.33,0,0,1,3.62-3.42L53.75,65.2l-3.59-9.59a10.19,10.19,0,0,1,4.5-12.42Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagCA;
exports["default"] = _default;